<template>
  <button class="sidebar-minimizer-header" type="button" @click="onClick()">
    <span class="navbar-toggler-icon"></span>
  </button>
</template>
<script>
import { togglePs } from '@coreui/vue/src/mixins/togglePs';

export default {
  name: 'sidebar-minimizer-header',
  mixins: [togglePs],
  mounted: function () {
    const isMinimized = document.body.classList.contains('sidebar-minimized');
    this.togglePs(!isMinimized);
  },
  methods: {
    onClick () {
      this.sidebarMinimize();
    },
    sidebarMinimize () {
      const isMinimized = document.body.classList.toggle('sidebar-minimized');
      this.$emit('cui-sidebar-minimize', isMinimized);
      this.togglePs(!isMinimized);
    },
    brandMinimize () {
      //document.body.classList.toggle('brand-minimized');
    }
  }
};
</script>

<style>
  .sidebar-minimizer-header {
    font-size: 1.25rem;
    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    min-width: 50px;
    padding: 0.25rem 0;
    cursor: pointer;
  }
</style>